import React, {Component} from 'react';
import './Admin.css';
import TeamTable from './TeamTable'

import { useQuery } from '@apollo/client';
import { FIND_TEAM_SMA } from '../../queries';

const AdminSMAPage = () => {
    const { error, data } = useQuery(FIND_TEAM_SMA);

    if (error) return `Error! ${error.message}`;

    return (
        <TeamTable teams={data?.findTeamSMA}/ >
    );
}

export default AdminSMAPage
